module.exports = __webpack_public_path__ + "img/202504_01.70e5a722.jpg";